import { TemplateQueryResponse } from '@common/types';
import { InfiniteData } from '@tanstack/react-query';

export const NUM_EMPTY_STATE_TEMPLATES_TO_DISPLAY = 12;

export const getSliceOfTemplates = (
  data: InfiniteData<TemplateQueryResponse | undefined, unknown> | undefined,
) => {
  const trimmedData =
    data?.pages?.[0]?.templates?.slice(
      0,
      NUM_EMPTY_STATE_TEMPLATES_TO_DISPLAY,
    ) ?? [];
  if (data?.pages?.[0]) {
    data.pages[0].templates = trimmedData;
  }
  return data;
};
